module.exports = __webpack_public_path__ + "img/p3_13.f05b446e.webp";